import styled from "styled-components";

const FluidChart = styled.div`
  .chart-graph {
    width: 100%;
  }
`;

export const ImpactWraper = styled(FluidChart)``;

export const TopListWraper = styled.div``;

export const ImpactContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  background-color: var(--section-snow-background-color, var(--snow));
  padding: 32px 24px;
  border-radius: 4px;

  hr {
    margin: 21px 0 -20px 0;
    background-color: ${"var(--divider-periwinkle-grey-background-color,var(--periwinkle-grey))"};
  }
`;
